import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/authContext';
import { Box } from '@mui/material';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

function EntertainmentTypeManagement() {
  const authCtx = useContext(AuthContext);

  if (!authCtx.checkRight('entertainmentType:read')) {
    return <Navigate to='/welcome' replace />;
  }

  const schema = {
    name: {
      label: 'Name',
      type: 'text',
      required: true,
      minWidth: '220px',
    },
    copagoOWGID: {
      label: 'Copago OWG ID',
      type: 'number',
      required: true,
      minWidth: '140px',
    },
    participantLaneDensity: {
      label: 'Teilnehmer/Lane Dichte',
      type: 'number',
      required: false,
      minWidth: '160px',
    },
    bookingWindowDistance: {
      label: 'Booking Window Distance',
      type: 'number',
      required: false,
      minWidth: '180px',
    },
    // Brands whose events start at a public meeting point in town rather than at
    // the venue (RallyeZone). Only their entertainments carry a "Rallye-Start",
    // and only they prefill the rallye start of a CRM deal. Switching it off
    // removes the address from those entertainments.
    hasRallyeStart: {
      label: 'Treffpunkt statt Standort (Rallye-Start)',
      type: 'boolean',
      required: false,
      minWidth: '220px',
    },
    // Brand identity used to render branded emails (transactional, proactive
    // compose and replies). logoUrl must be a publicly reachable image; the
    // color fields accept any CSS color (e.g. a hex value like #00228f). When a
    // field is left empty the email renderer derives it from the CI colors and
    // finally falls back to the FunZone default branding.
    branding: {
      label: 'E-Mail-Branding',
      type: 'object',
      required: false,
      excludeFromAdd: true,
      excludeFromList: true,
      displayValue: value => {
        if (!value || typeof value !== 'object') return 'Standard (FunZone)';
        const parts = [];
        if (value.logoUrl) parts.push('Logo');
        if (value.primaryColor || value.secondaryColor) parts.push('Farben');
        return parts.length > 0 ? parts.join(', ') : 'Standard (FunZone)';
      },
      schema: {
        logoUrl: {
          label: 'Logo-URL',
          type: 'text',
          required: false,
          placeholder: 'https://booking.fun-zone.de/logo/laserzone.png',
        },
        primaryColor: {
          label: 'Primärfarbe (CI)',
          type: 'text',
          required: false,
          placeholder: 'z.B. #00228f',
        },
        secondaryColor: {
          label: 'Sekundärfarbe (CI)',
          type: 'text',
          required: false,
          placeholder: 'z.B. #ffff00',
        },
        emailHeaderBgColor: {
          label: 'E-Mail Kopf-Hintergrund',
          type: 'text',
          required: false,
          placeholder: 'Leer = Sekundärfarbe',
        },
        emailFooterBgColor: {
          label: 'E-Mail Fuß-Hintergrund',
          type: 'text',
          required: false,
          placeholder: 'Leer = Primärfarbe',
        },
        emailFooterTextColor: {
          label: 'E-Mail Fuß-Textfarbe',
          type: 'text',
          required: false,
          placeholder: 'Leer = Standard',
        },
        emailAccentColor: {
          label: 'E-Mail Akzentfarbe',
          type: 'text',
          required: false,
          placeholder: 'Leer = Primärfarbe',
        },
      },
    },
  };

  return (
    <Box sx={viewRootTextPrimarySx}>
    <EditableList
      schema={schema}
      title='Neuen Entertainment-Typ anlegen'
      resourceType='entertainmentType'
      searchPlaceholder='Entertainment-Typen durchsuchen'
      parentIsEditable={authCtx.checkRight('entertainmentType:update')}
      options={{ titleKey: 'name' }}
    />
    </Box>
  );
}

export default EntertainmentTypeManagement;
